/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AgentBadge_agent$ref = any;
type AgentUpgradeBanner_agent$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventAccepted_event$ref: FragmentReference;
export type JobEventAccepted_event = {|
  +timestamp: any,
  +actor: {|
    +node: ?{|
      +hostname?: ?string,
      +version?: ?string,
      +versionHasKnownIssues?: boolean,
      +isDeprecated?: boolean,
      +operatingSystem?: ?{|
        +name: string
      |},
      +$fragmentRefs: AgentBadge_agent$ref & AgentUpgradeBanner_agent$ref,
    |}
  |},
  +$refType: JobEventAccepted_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventAccepted_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentBadge_agent",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "AgentUpgradeBanner_agent",
              "args": null
            },
            {
              "kind": "InlineFragment",
              "type": "Agent",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hostname",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "version",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "versionHasKnownIssues",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isDeprecated",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "operatingSystem",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "OperatingSystem",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "name",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7a5afe0c18fb9948b31d6bc9cc203ed6';
module.exports = node;
